module.exports = __webpack_public_path__ + "img/icon-fish.4a78c8b.webp";